import { Stores } from "src/features/stores/components/Stores/Stores"

import React, { useCallback } from "react"
import { useStoresSWR } from "src/hooks/useStoresSWR"

export const StoresContainer: React.VFC = () => {
  const { storesSwr } = useStoresSWR()

  const handleStoreAdded = useCallback(() => {
    storesSwr.mutate()
  }, [storesSwr])

  return <Stores stores={storesSwr.data?.stores} onStoreAdded={handleStoreAdded} />
}
